import React from 'react';
import { PapiDeviationCommission } from '@wix/da-papi-types';
import { DetailsProps } from '../types';
import SubmissionDetails from '../../../SubmissionDetails';
import TextRenderer from '../../../TextRenderer';
import { isEditorTextEmpty } from '@wix/da-editor-tiptap/pkg/components/utils/helpers';
import MeasuredTorpedo from '../../../Torpedo/MeasuredTorpedo';
import { Item as DeviationTorpedoItem } from '../../../Torpedo/DeviationTorpedo/DeviationTorpedo';
import { TorpedoProps } from '../../../Torpedo/Torpedo';
import { TorpedoLayoutedItem } from '../../../Torpedo/types';
import DeviationThumbView from '../../../DeviationViews/Thumb/Standard';
import { MeasuredCookieType } from '@wix/da-hooks/pkg/useMeasureElement/redux/types';
import MediaService from '../../../utils/DeviationMediaService';
import DeviationAttributeCSV from '../_partials/DeviationAttributeCSV';
import CommissionViewerV3 from '@wix/da-editor-tiptap/pkg/components/Viewer/presets/Commission';

import s from './Commission.scss';

const exampleRenderer = (
  renderProps: TorpedoProps,
  item: TorpedoLayoutedItem<DeviationTorpedoItem>
) => {
  return (
    <DeviationThumbView
      className={s['example']}
      deviation={item.dto.deviation}
      width={item.width}
      height={item.height}
    />
  );
};

export const CommissionDetails: React.FC<DetailsProps> = ({
  deviation,
  deviation: { commission: { examples = [] } = {} as PapiDeviationCommission, textContent },
}) => {
  const isEmpty = textContent && isEditorTextEmpty(textContent);
  return (
    <div className={s['root']}>
      <div className={s['author-block']}>
        <SubmissionDetails deviation={deviation} />
      </div>
      {!isEmpty && (
        <TextRenderer
          className={s['description']}
          textContent={textContent}
          viewerKey={deviation.deviationId}
          tipTapViewer={CommissionViewerV3}
          cookieType={MeasuredCookieType.DEVIATION_DESCRIPTION}
          defaultSize={{
            desktop: { width: 780, height: 800 },
            mobile: { width: 380, height: 400 },
          }}
          withSafetyCheckModal
        />
      )}
      {examples.length > 0 && (
        <div className={s['examples']}>
          <MeasuredTorpedo
            container={{ width: 780 }}
            items={examples.map(item => {
              const largest = MediaService.getThumbDimensions(item);
              return {
                id: `deviation-${item.deviationId}`,
                width: largest.width || 0,
                height: largest.height || 0,
                deviation: item,
              };
            })}
            renderItem={exampleRenderer}
            cookieDim="width"
            cookieType={MeasuredCookieType.BROWSE}
          />
        </div>
      )}
      <div className={s['misc']}>
        <DeviationAttributeCSV deviation={deviation} />
      </div>
    </div>
  );
};
CommissionDetails.displayName = 'CommissionDetails';

export default CommissionDetails;
